module.exports = __webpack_public_path__ + "img/tiktok.3a7e128a.png";